import React, { useContext } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Loader } from '@mantine/core';
import { Context as AuthContext } from '../../../providers/AuthContextProvider';
import StoreSetupGuideView from './StoreSetupGuideView';
import StoreAnalyticsView from './StoreAnalyticsView';
import AppStack from '../../common/AppStack';

const StoreDashboardOverview = () => {
  const { state: authState } = useContext(AuthContext);
  const ecomStore = authState.ecomStores.find(
    (v) => v.pkEcomStore.toString() === authState.pkEcomStore?.toString()
  );

  return !ecomStore ? (
    <AppStack
      style={{
        flex: 1,
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Loader color="dark" size="xl" />
    </AppStack>
  ) : (
    <Routes>
      {!ecomStore?.sandboxEnabled ? (
        <>
          <Route element={<StoreAnalyticsView />} path="/" />
          <Route element={<StoreSetupGuideView />} path="/setup-guide" />
        </>
      ) : (
        <>
          <Route element={<StoreSetupGuideView />} path="/" />
          <Route element={<StoreSetupGuideView />} path="/setup-guide" />
        </>
      )}
      <Route element={<Navigate replace to="/merchant" />} path="*" />
    </Routes>
  );
};

export default StoreDashboardOverview;
